import { Action } from "./Action.js";
import { getElementByIdInContext } from "../lib/utils.js";
/**
 * @class CallMethod
 * @extends Action
 * @classdesc Действие Вызвать метод
 * Вызвать метод у Тренда или Журнала
 * */
export class CallMethod extends Action {
    execute() {
        // поскольку на странице могут быть несколько экземпляторов объектов,
        // то у них будут одинаковые id, поэтому нужно искать нужный объект внутри родительского окна
        const element = getElementByIdInContext(this.context, this.ElementId);
        if (typeof element[this.MethodName] !== "function") {
            return;
        }

        element[this.MethodName](this.parameters);
    }
}
